
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#008CFF","d":"M42.412 2c1.62 2.662 2.348 5.408 2.348 8.875 0 11.057-9.473 25.417-17.162 35.5H10.04L3 4.421l15.379-1.454 3.74 29.85c3.475-5.648 7.773-14.523 7.773-20.57 0-3.313-.57-5.565-1.46-7.42z"}})])
          )
        }
      }
    